// @flow

import queryString from 'query-string';

import { addTruthyParamsToUrl, isBrowser } from '@zapier/common-utils';

import { APPS_PAGES_MOUNT_POINT } from 'web-ssr/app/common/constants';

export const buildSignUpUrl = (options: {
  next?: string,
  serviceIds?: Array<string>,
}) => {
  const referrer =
    isBrowser() && queryString.parse(window.location.search).referrer;

  return addTruthyParamsToUrl('/sign-up/', {
    next: options.next,
    selected_apis: (options.serviceIds || []).join(','),
    referrer,
  });
};

export const createAbsoluteURL = (path: string) => `https://zapier.com${path}`;

export const createAppsPageLink = (url: string) =>
  `/${APPS_PAGES_MOUNT_POINT}/${url}`;

export const createServiceOverviewPageLink = (serviceSlug: string) =>
  createAppsPageLink(`${serviceSlug}`);

export const createServiceIntegrationsPageLink = (serviceSlug: string) =>
  createAppsPageLink(`${serviceSlug}/integrations`);

export const createServiceAlternativesPageLink = (serviceSlug: string) =>
  createAppsPageLink(`${serviceSlug}/alternatives`);

export const createServiceMediaPageLink = (serviceSlug: string) =>
  createAppsPageLink(`${serviceSlug}/media`);

export const createServiceUpdatesPageLink = (serviceSlug: string) =>
  createAppsPageLink(`${serviceSlug}/updates`);

export const createServiceHelpPageLink = (serviceSlug: string) =>
  createAppsPageLink(`${serviceSlug}/help`);

export const createServicePricingPageLink = (serviceSlug: string) =>
  createAppsPageLink(`${serviceSlug}/pricing`);

export const createServiceTutorialsPageLink = (serviceSlug: string) =>
  createAppsPageLink(`${serviceSlug}/tutorials`);

export const createServiceBlogPostDetailsLink = (
  serviceSlug: string,
  tutorialSlug: string
) => createAppsPageLink(`${serviceSlug}/tutorials/${tutorialSlug}`);

export const createTwoServicePageLink = (
  primaryServiceSlug: string,
  secondaryServiceSlug: string
) =>
  createAppsPageLink(
    `${primaryServiceSlug}/integrations/${secondaryServiceSlug}`
  );

export const createZapTemplatePageLink = (
  primaryServiceSlug: string,
  secondaryServiceSlug: string,
  zapId: string,
  zapSlug: string
) =>
  `${createTwoServicePageLink(
    primaryServiceSlug,
    secondaryServiceSlug
  )}/${zapId}/${zapSlug}`;

export const createOneAppEditorLink = (
  primaryAppImplementationId: string
): string => `/zapbook/create/${primaryAppImplementationId}`;

export const createTwoAppEditorLink = (
  primaryAppImplementationId: string,
  secondaryAppImplementationId: string
): string =>
  `/zapbook/create/${primaryAppImplementationId}/${secondaryAppImplementationId}`;
